module.exports = __webpack_public_path__ + "img/kommune-119.b7f6c4c5.svg";